import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/privacy-policy")({
  staticData: { title: "Privacy Policy" },
  component: lazyRouteComponent(
    () => import("#pages/legal/privacy-policy.tsx"),
    "PrivacyPolicy",
  ),
})
